import React from 'react';
import { Typography } from 'antd';
import { ProjectOutlined } from '@ant-design/icons';
import { ProjeMasrafTab } from '../insaat/tabs';
import './Finans.css';
import '../ortak/nfmodules.css';

const { Title } = Typography;

// Proje / İhale Masrafları — Finans altında bağımsız sayfa (/proje-masraflari).
// Veri: maliyetler (masraf_tipi=10), proje bağı: kesif_talepleri (metin arama).
export default function ProjeMasrafPage() {
  return (
    <div className="nf-module finans-page">
      <Title level={3} style={{ marginTop: 0 }}>
        <ProjectOutlined style={{ marginRight: 8 }} /> Proje Masrafları
      </Title>
      <ProjeMasrafTab />
    </div>
  );
}
